export default {
  buttons: {
    login: 'Login',
    sign_in_sign_up: 'Anmelden/ Registrieren',
  },
};
